export default __webpack_public_path__ + "static/media/create-order-modal.c665c4f3.png";